import styled from 'styled-components'

type ContainerProps = {
  modalOpen: boolean
}

export const Chart = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  width: ${props => (props.modalOpen ? '900px' : '450px')};
  height: ${props => (props.modalOpen ? '630px' : '315px')};
  background: white;
  border-radius: 20px;
  box-shadow: 4px 4px 18px -5px rgba(218, 221, 232, 0.8);
  margin-bottom: 1rem;
  position: relative;
  @media (max-width: 768px) {
    height: 315px;
    width: 300px;
  }
  @media (max-width: 480px) {
    height: 315px;
    width: 100%;
  }
`
export const ChartHeader = styled.div`
  padding: 1rem;
  margin: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f6f6f6;
`

export const ChartBody = styled.div`
  padding: 0.6rem 1.2rem;
  height: 100%;
  display: flex;
  flex: 1;
  align-items: center;
`
